import { render, staticRenderFns } from "./zzDetail.vue?vue&type=template&id=5380f976"
import script from "./zzDetail.vue?vue&type=script&lang=js"
export * from "./zzDetail.vue?vue&type=script&lang=js"
import style0 from "./zzDetail.vue?vue&type=style&index=0&id=5380f976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports